import { Component, Input } from '@angular/core';
import { LdapLayerViewDetails } from 'private/app/models/user.model';

@Component({
    selector: 'hvac-layer-view-ldap-data',
    templateUrl: './layer-view-ldap-data.component.html',
    styleUrls: ['./layer-view-ldap-data.component.scss']
})
export class LayerViewLdapDataComponent {
    @Input() ldapData: LdapLayerViewDetails[];
}
